import { sendToParent } from './iframe-bridge'

let observer: ResizeObserver | null = null

/**
 * Watches the document body and sends `iframe:resize` messages to the parent
 * whenever the content height changes.  The host page can listen for this to
 * dynamically adjust the iframe height and avoid inner scrollbars.
 */
export function startAutoResize() {
  if (observer) return

  const notify = () => {
    const height = document.documentElement.scrollHeight
    sendToParent('iframe:resize', { height })
  }

  observer = new ResizeObserver(notify)
  observer.observe(document.body)

  notify()
}

export function stopAutoResize() {
  observer?.disconnect()
  observer = null
}
